module.exports = __webpack_public_path__ + "img/thumbnail_LarGibbon_m_normal.e2718561.png";